import React from 'react';

const Header = () => {
    return (
        <div>
            <h1>Welcome To My Book Store</h1>
        </div>
    );
};

export default Header;